<div class="languages-switcher" [nbPopover]="switcherListComponent" nbPopoverPlacement="bottom" [nbPopoverContext]="{popover: popover}">
  <i class="fa fa-globe"></i>
  <span *ngIf="showTitle" translate>Language</span>
</div>
